import React from "react";

const Header = () => {
  return (
    <React.Fragment>
      <div id="loading-area" className="loading-page-3">
        <div className="loader">
          <img className="slideskew" src="assets/images/loader.gif" alt="" />
        </div>
      </div>
      {/* <div className="page-wraper"> */}
      <header className="site-header mo-left header header-transparent style-1">
        <div className="sticky-header main-bar-wraper navbar-expand-lg">
          <div className="main-bar clearfix">
            <div className="container clearfix">
              <div className="logo-header mostion logo-dark">
                <a href="/" style={{ fontSize: "20px", fontWeight: "600" }}>
                  <p
                    style={{
                      borderLeft: "1px solid #3b6ff5",
                      paddingLeft: "2%",
                    }}
                  >
                    Liberty Web 
                    <span style={{ letterSpacing: "2px", color: "#3b6ff5" }}>
                       &nbsp;Guard
                    </span>
                  </p>
                </a>
              </div>
              <button
                className="navbar-toggler collapsed navicon justify-content-end"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              <div className="extra-nav">
                <div className="extra-cell">
                  <a
                    href="/CreateTask"
                    className="btn btn-primary btn-hover-13"
                  >
                    <span>Create Task</span>Create Task
                  </a>
                </div>
              </div>
              <div
                className="header-nav navbar-collapse collapse justify-content-end"
                id="navbarNavDropdown"
              >
                <div className="logo-header logo-dark" style={{paddingBottom: "0"}}>
                  <a href="/">
                    <p
                      style={{
                        borderLeft: "1px solid #3b6ff5",
                        paddingLeft: "2%",
                        fontSize: "25px",
                        marginBottom: "0"
                      }}
                    >
                      Liberty Web
                      <span style={{ letterSpacing: "2px", color: "#3b6ff5" }}>
                        &nbsp; Guard
                      </span>
                    </p>
                  </a>
                </div>
                <hr/>
                <ul className="nav navbar-nav navbar navbar-left">
                  <li>
                    <a href="/Dashboard">Home</a>
                  </li>
                  <li className="sub-menu-down">
                    <a href="javascript:void(0);">Jobs</a>
                    <ul className="sub-menu">
                      <li>
                        <a href="/MyPlans">My Plans</a>
                      </li>
                      <li>
                        <a href="/AllPlans">All Plans / Jobs</a>
                      </li>
                    </ul>
                  </li>
                  <li className="sub-menu-down">
                    <a href="javascript:void(0);">Task</a>
                    <ul className="sub-menu">
                      <li>
                        <a href="/CreateTask">Start Task</a>
                      </li>
                      <li>
                        <a href="/MyTask">My Task</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="/MyEarnings">Earnings</a>
                  </li>
                  <li className="sub-menu-down">
                    <a href="javascript:void(0);">Profile</a>
                    <ul className="sub-menu">
                      <li>
                        <a href="/WithDrawal">Withdrawal</a>
                      </li>
                      <li>
                        <a href="/Transactions">My Transactions</a>
                      </li>
                      <li>
                        <a href="/Profile">Update Profile</a>
                      </li>
                      <li>
                        <a href="/ChangePassword">Change Password</a>
                      </li>
                      <li>
                        <a href="/UpdateBankDetails">Update Bank</a>
                      </li>
                      <li>
                        <a href="/RefferalCode">Referral</a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="/">Logout</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
